import { render, staticRenderFns } from "./formCard.vue?vue&type=template&id=4c927b1b&"
import script from "./formCard.vue?vue&type=script&lang=js&"
export * from "./formCard.vue?vue&type=script&lang=js&"
import style0 from "./formCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports